import { useState } from 'react'
import { Grid } from '@mui/material'

import Select from './Select'
import GridIconButton from './GridIconButton'
import GridTimePicker from './GridTimePicker'
import { sortAlphabetically } from '../hooks/sort-functions'
import { GIORNI } from '../settings/settings'

const GridWeeklyTimeSlotChoice = ({ values, onChange = () => {} }) => {
  const [newSlot, setNewSlot] = useState()

  const cSetNewSlot = (field, value) =>
    setNewSlot({ ...newSlot, [field]: value })

  const MyGridTimePicker = ({ label, field }) => (
    <GridTimePicker
      label={label}
      field={field}
      value={newSlot?.[field]}
      onChange={cSetNewSlot}
    />
  )

  const addSlot = () => {
    onChange(
      (values || [])
        ?.concat(newSlot)
        ?.sort(
          (a, b) =>
            GIORNI.findIndex(d => d === a.giorno) -
              GIORNI.findIndex(d => d === b.giorno) ||
            sortAlphabetically(a.dalle, b.dalle),
        ),
    )
    setNewSlot()
  }

  if (!newSlot)
    return (
      <GridIconButton
        type='add'
        size={12}
        noCenter
        iconSize='small'
        onClick={() => setNewSlot({})}
        text='Nuova fascia oraria'
      />
    )

  return (
    <Grid container spacing={2} alignItems='center' sx={{ width: '100%' }}>
      <Grid size={{ xs: 12, md: 3 }}>
        <Select
          label='Giorno'
          value={newSlot?.giorno}
          options={GIORNI?.filter(g => !values?.some(v => v.giorno === g))}
          onChange={i => setNewSlot({ ...newSlot, giorno: i })}
        />
      </Grid>
      <MyGridTimePicker label='Dalle (inizio gara)' field='dalle' />
      <MyGridTimePicker label='Alle (inizio gara)' field='alle' />
      <GridIconButton
        type='save'
        size={{ xs: 6, md: 1 }}
        onClick={addSlot}
        disabled={!newSlot?.giorno || !newSlot?.dalle || !newSlot?.alle}
      />
      <GridIconButton
        type='clear'
        size={{ xs: 6, md: 1 }}
        onClick={() => setNewSlot()}
      />
    </Grid>
  )
}

export default GridWeeklyTimeSlotChoice
